export const calculateScore = (baseline, increase = 0) =>
  baseline * 3 + increase * 9;
